import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import {
  NewYear2026Status,
  NewYear2026StatusResponse,
  Winner,
  WinnersRequest,
  WinnersResponse,
} from './types'
import { isAllElementsOfSearchTextNotExist } from '../../../../libs/utils'

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      if (item[0] === 'client.clientId') {
        return [`client.id`, item[1]?.toLowerCase()]
      }
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

export const newYear2026StatusMounted = createEvent()

export const changeStatusSubmit = createEvent()

export const winnersListMounted = createEvent<WinnersRequest>()

export const setIsChangeStatusSuccess = createEvent<boolean>()

export const $isChangeStatusSuccess = restore(setIsChangeStatusSuccess, false)

export const getNewYear2026Status = fx<void, NewYear2026StatusResponse>({
  method: 'GET',
  url: `/promo/new_year_2026/promo`,
})

export const getWinners = fx<WinnersRequest, WinnersResponse>({
  method: 'GET',
  url: `/promo/new_year_2026/winner`,
})

export const changeStatus = fx<void, void>({
  method: 'PUT',
  url: `/promo/new_year_2026/promo/{id}`,
})

export const $newYear2026Status = restore<NewYear2026Status[]>(
  getNewYear2026Status.doneData.map((a) => a.body.items),
  [],
)

export const $winners = restore<Winner[]>(
  getWinners.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfWinners = restore(
  getWinners.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: newYear2026StatusMounted,
  fn: () => {},
  target: getNewYear2026Status,
})

sample({
  // @ts-ignore
  clock: changeStatusSubmit,
  fn: () => {
    return {
      url: '/promo/new_year_2026/promo/1',
      body: {
        status: 'results',
      },
    }
  },
  target: changeStatus,
})

sample({
  // @ts-ignore
  clock: winnersListMounted,
  fn: ({ limit, page, orderBy, orderDirection, filters, searchText }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }

    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            key === 'prizeType'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    return {
      query,
    }
  },
  target: getWinners,
})

sample({
  clock: changeStatus.doneData,
  fn: () => {
    return true
  },
  target: setIsChangeStatusSuccess,
})
